import { Input } from 'components';
import { memo } from 'react';
import { TableComponents } from '../../';

const AthleteTierItem = memo(
  ({ tierPricing, country, currency, currencySymbols, handleChange, errors, handleError }) => {
    const disabledBgColor = 'rgba(121, 137, 160, 0.2)';
    return (
      <TableComponents.Tr>
        <TableComponents.Td valign="unset" noBorder>
          <Input wid="140px" disabled defaultValue={country} bg={disabledBgColor} />
        </TableComponents.Td>
        <TableComponents.Td valign="unset" noBorder>
          <Input
            wid="140px"
            currency
            align="right"
            step={0.01}
            placeholder={currencySymbols[currency]}
            prefix={currencySymbols[currency]}
            value={tierPricing[currency].amount}
            onValueChange={(val) => {
              handleChange(currency, 'price', val);
              handleError(currency, 'price', val);
            }}
          />
        </TableComponents.Td>
        <TableComponents.Td valign="unset" noBorder>
          <Input
            currency
            wid="80px"
            align="right"
            placeholder="%"
            suffix="%"
            prefix=""
            value={tierPricing[currency].serviceFeePct}
            onValueChange={(val) => {
              handleChange(currency, 'fee', val);
              handleError(currency, 'fee', val);
            }}
            error={errors.find((x) => x.input === 'fee' && x.currency === currency)?.err}
          />
        </TableComponents.Td>
        <TableComponents.Td valign="unset" noBorder>
          <Input
            wid="140px"
            currency
            align="right"
            placeholder={currencySymbols[currency]}
            prefix={currencySymbols[currency]}
            value={tierPricing[currency].serviceFee}
            disabled
            bg={disabledBgColor}
          />
        </TableComponents.Td>
        <TableComponents.Td valign="unset" noBorder>
          <Input
            wid="140px"
            currency
            align="right"
            placeholder={currencySymbols[currency]}
            prefix={currencySymbols[currency]}
            value={tierPricing[currency].athleteFee}
            disabled
            bg={disabledBgColor}
          />
        </TableComponents.Td>
      </TableComponents.Tr>
    );
  }
);

export default AthleteTierItem;
